<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" :disabled='isLoading' @keyup="search" v-model.trim="data" class="form-control " v-bind:class="[ (hasSearchString) ? 'border-right-0' : '']" :placeholder="placeholder">
                        <span v-if="hasSearchString" class="input-group-append">
                            <button class="btn btn-white border border-left-0" type="button" @click="clear"><i class="icon-cross"></i></button>
                        </span>
                        <span v-if="allowAdvanced" class="input-group-append">
                            <button class="btn btn-white border border-left-0" type="button" @click="showFields = !showFields"><i v-bind:class="[ (showAdvanced) ? 'text-primary' : '' , (isAdvancedFilled) ? 'icon-filter3' : 'icon-filter4' ]"></i></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <slot v-if="showAdvanced" ></slot>
    </div>
    <!--
    <div class="form-group" :inputclass="inputclass">
        <label v-if="label != ''">{{label}}</label>
        <div class="input-group">
            <input type="text" :disabled='isLoading' @keyup="search" v-model.trim="data" class="form-control " v-bind:class="[ (hasSearchString) ? 'border-right-0' : '']" :placeholder="placeholder">
            <span v-if="hasSearchString" class="input-group-append">
                <button class="btn btn-white border border-left-0" type="button" @click="clear"><i class="icon-cross"></i></button>
            </span>
            <span v-if="allowAdvanced" class="input-group-append">
                <button class="btn btn-white border border-left-0" type="button" @click="clear"><i class="icon-filter4"></i></button>
            </span>
        </div>
    </div>
    -->
</template>

<script>

export default {
    props: {
        value: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        label :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        allowAdvanced : {
            type: Boolean,
            default: true
        },
        isAdvancedFilled : {
            type: Boolean,
            default: false
        }
    },
    watch : {
        value(v){
            this.data = v
        },
        data(){

        },
        isAdvancedFilled(){}
    },
    data() {
        return {
            timeoutSearch : null,
            data : this.value,
            showFields : false
        }
    },
    computed : {
        showAdvanced : function(){
            return this.allowAdvanced && this.showFields
        },
        hasSearchString : function(){
            return !(this.data == '' || this.data == null)
        }
    },
    mounted(){
        this.initialize();
    },
    methods : {
        initialize : function(){
            this.data = this.value;
        },
        search : function(){
            clearTimeout(this.timeoutSearch);
            this.timeoutSearch = setTimeout(function () {
                this.$emit("input", this.data);
            }.bind(this), 400);
        },
        clear : function(){
            this.data = '';
            this.search();
        }
    }

};
</script>